var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"button-group-wrap",class:[_vm.padding ? 'button-group-wrap--padding' : 'button-group-wrap--normal']},_vm._l((_vm.options),function(item,index){return _c('el-button',{key:index,staticClass:"button-group-item",class:{
			'button-group-item--active': item.value === _setup.innerValue
		},on:{"click":function($event){return _setup.changeButton(item)}}},[_vm._v(_vm._s(item.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }